import { combineReducers } from 'redux'
import uuidv4 from 'uuid/v4'
import TYPES from './actionTypes'
import { config } from 'cmw-goaltools'
const { investorProfile, assetClassReturns } = config

function profile(
  state = { ...investorProfile, planName: 'My Plan' },
  { type, payload }
) {
  switch (type) {
    case TYPES.SET_PLAN_PROP:
      return {
        ...state,
        [payload.key]: payload.value,
      }

    case TYPES.LOAD_PROFILE:
      return {
        ...payload.profile,
        planName: payload.profile.planName.replace('WAPLWFP', '').trim(),
      }

    default:
      return state
  }
}

function goals(state = {}, { type, payload }) {
  switch (type) {
    case TYPES.CREATE_GOAL:
      return { ...state, ...payload }

    case TYPES.DELETE_GOAL:
      let newState = { ...state }
      delete newState[payload]
      return newState

    case TYPES.SET_GOAL_PROP:
      return {
        ...state,
        [payload.id]: {
          ...state[payload.id],
          [payload.key]: payload.value,
        },
      }

    case TYPES.DELETE_ALL_GOALS:
      return {}

    case TYPES.LOAD_GOALS:
      return payload.goals

    default:
      return state
  }
}

function activeGoal(state = null, { type, payload }) {
  switch (type) {
    case TYPES.SET_ACTIVE_GOAL:
      return payload

    default:
      return state
  }
}

function globalSettings(state = { assetClassReturns }, { type, payload }) {
  switch (type) {
    case TYPES.SET_GLOBAL_SETTING:
      return {
        ...state,
        [payload.setting]: {
          ...state[payload.setting],
          [payload.key]: payload.value,
        },
      }
    case TYPES.LOAD_GLOBAL_SETTINGS:
      return payload.globalSettings
    default:
      return state
  }
}

function session(state = { id: uuidv4() }, { type, payload }) {
  switch (type) {
    case TYPES.SET_SHARE_ID:
      return {
        ...state,
        share_id: payload.value,
      }
    default:
      return state
  }
}

function display(state = { menuOpen: false }, { type }) {
  switch (type) {
    case TYPES.TOGGLE_MOBILE_MENU:
      return {
        ...state,
        menuOpen: !state.menuOpen,
      }
    default:
      return state
  }
}

export default combineReducers({
  profile,
  goals,
  activeGoal,
  globalSettings,
  session,
  display,
})



// WEBPACK FOOTER //
// ./src/store/reducers.js